module.exports = __webpack_public_path__ + "static/img/IMG_20170525_105936.2182dcdf.jpg";